import type { ReactNode } from "react";

import { useApplicationDetail } from "../hooks/use-application-detail";

const ApplicationDetailPageMessage = ({ children }: { children: string }) => (
  <main className="bg-neutrals-99 flex min-h-0 w-full flex-1 flex-col overflow-y-auto px-8 py-6">
    <div className="mx-auto w-full max-w-[76rem]">
      <p className="paragraph-base text-type-minor py-10 text-center">{children}</p>
    </div>
  </main>
);

const ApplicationDetailPageSkeleton = () => (
  <div className="bg-neutrals-99 flex h-auto w-full flex-1 flex-col px-8 pb-6 pt-6">
    <div className="skeleton h-[13.5rem] w-full" />
    <div className="skeleton mb-4 mt-9 h-8 w-full" />
    <div className="skeleton min-h-[25rem] w-full flex-1" />
  </div>
);

type ApplicationDetailPageContentProps = {
  children: ReactNode;
};

export const ApplicationDetailPageContent = ({ children }: ApplicationDetailPageContentProps) => {
  const { isLoading, isError, application } = useApplicationDetail();

  if (isLoading) {
    return <ApplicationDetailPageSkeleton />;
  }

  if (isError) {
    return <ApplicationDetailPageMessage>Не удалось загрузить заявку</ApplicationDetailPageMessage>;
  }

  if (!application) {
    return <ApplicationDetailPageMessage>Заявка не найдена</ApplicationDetailPageMessage>;
  }

  return children;
};
